import * as AddToBasketEvent from '@ori-events/add-to-basket';
import { EmptyBasket, AddToBag, AddToBagFilled, OriflameSpinner, EmptyBasketFilled } from '@ori-ui/icons';
import useTestId from '@ori/testid-generator';
import { useCallback, useState } from 'react';
import { QUICK_BUY_BUTTON_STATE_DEFAULT, QUICK_BUY_BUTTON_STATE_LOADING, QUICK_BUY_BUTTON_STATE_SUCCESS, QUICK_BUY_FILLED_CN_ICON, QUICK_BUY_FILLED_ICON, QUICK_BUY_LOADING_ICON, QUICK_BUY_OUTLINED_CN_ICON, QUICK_BUY_OUTLINED_ICON } from '../../common';
import { Markets } from './helpers';
import { useOnClickEvent, useQuickBuyEvents } from './hooks';
import { Root } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
const renderIcon = (state, tenant, hover) => {
  switch (state) {
    case QUICK_BUY_BUTTON_STATE_LOADING:
      return /*#__PURE__*/_jsx(OriflameSpinner, {
        "data-testid": QUICK_BUY_LOADING_ICON,
        fontSize: "inherit"
      });
    case QUICK_BUY_BUTTON_STATE_SUCCESS:
      if (tenant === Markets.CN) {
        return /*#__PURE__*/_jsx(EmptyBasketFilled, {
          "data-testid": QUICK_BUY_FILLED_CN_ICON,
          fontSize: "inherit"
        });
      }
      return /*#__PURE__*/_jsx(AddToBagFilled, {
        "data-testid": QUICK_BUY_FILLED_ICON,
        fontSize: "inherit"
      });
    default:
      if (hover) {
        if (tenant === Markets.CN) {
          return /*#__PURE__*/_jsx(EmptyBasketFilled, {
            "data-testid": QUICK_BUY_FILLED_CN_ICON,
            fontSize: "inherit"
          });
        }
        return /*#__PURE__*/_jsx(AddToBagFilled, {
          "data-testid": QUICK_BUY_FILLED_ICON,
          fontSize: "inherit"
        });
      }
      if (tenant === Markets.CN) {
        return /*#__PURE__*/_jsx(EmptyBasket, {
          "data-testid": QUICK_BUY_OUTLINED_CN_ICON,
          fontSize: "inherit"
        });
      }
      return /*#__PURE__*/_jsx(AddToBag, {
        "data-testid": QUICK_BUY_OUTLINED_ICON,
        fontSize: "inherit"
      });
  }
};
export const QuickBuyButton = ({
  addToBasketMethod,
  currentPrice,
  currentProductCode,
  lineNumber,
  name,
  originalItemCode,
  placement,
  position,
  tenant = '',
  hasAutoSubscription,
  isMultiShade,
  onQuickBuyButtonClick,
  ...restProps
}) => {
  const [state, setState] = useState(QUICK_BUY_BUTTON_STATE_DEFAULT);
  const {
    getTestId
  } = useTestId();
  useQuickBuyEvents({
    currentProductCode,
    setState
  });
  const onClickEvent = useOnClickEvent({
    addToBasketMethod,
    currentPrice,
    currentProductCode,
    lineNumber,
    name,
    originalItemCode,
    placement,
    position,
    isMultiShade,
    hasAutoSubscription,
    onQuickBuyButtonClick
  });
  const dispatchOnClickEvent = useCallback(() => {
    if (onClickEvent instanceof CustomEvent) {
      if (onClickEvent.type === AddToBasketEvent.Name) {
        setState(QUICK_BUY_BUTTON_STATE_LOADING);
      }
      window.dispatchEvent(onClickEvent);
    }
  }, [onClickEvent]);
  const onClick = useCallback(event => {
    event.preventDefault();
    event.stopPropagation();
    if (onClickEvent instanceof CustomEvent && state === QUICK_BUY_BUTTON_STATE_DEFAULT) {
      if (onQuickBuyButtonClick) {
        onQuickBuyButtonClick({
          event: onClickEvent,
          initialState: state,
          setState
        });
      } else {
        dispatchOnClickEvent();
      }
    }
  }, [dispatchOnClickEvent, onClickEvent, onQuickBuyButtonClick, state]);
  return /*#__PURE__*/_jsx(Root, {
    "data-testid": `${getTestId('quick-buy')}-${currentProductCode}`,
    color: "default",
    hoverIcon: renderIcon(state, tenant, true),
    size: "large",
    state: state,
    tenant: tenant,
    variant: "contained",
    onClick: onClick,
    ...restProps,
    children: renderIcon(state, tenant, false)
  });
};
//# sourceMappingURL=QuickBuyButton.js.map